import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { copyToClipboard } from "../utils/copy_to_clipboard"
import { showHubTeamToast } from "../utils/hub_team_toast"

// "Share internally" for course and path cards. Lives on the page root so every
// card's share button reaches the one modal; the button that opened it carries the
// URL to copy in data-share-url.
export default class extends Controller {
  static targets = ["modal", "copyButton"]

  connect() {
    this.focusCopyButton = () => {
      if (this.hasCopyButtonTarget) this.copyButtonTarget.focus()
    }
    if (this.hasModalTarget) this.modalTarget.addEventListener("shown.bs.modal", this.focusCopyButton)
  }

  disconnect() {
    if (this.hasModalTarget) this.modalTarget.removeEventListener("shown.bs.modal", this.focusCopyButton)
  }

  open(event) {
    event.preventDefault()
    this.shareUrl = event.currentTarget.dataset.shareUrl
    if (!this.shareUrl || !this.hasModalTarget) return

    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  async copy(event) {
    event.preventDefault()
    const copied = await copyToClipboard(this.shareUrl)

    if (!copied) {
      showHubTeamToast("Couldn't copy the link. Try again, or copy it from the address bar after opening it.", { variant: "error" })
      return
    }

    showHubTeamToast("Link copied")
    Modal.getOrCreateInstance(this.modalTarget).hide()
  }
}
